<template>
  <div
    v-if="lessons"
    class="bg-blue-dark-50 py-12 px-6 rounded-2xl"
  >
    <ol
      role="list"
      class="flex flex-col items-center"
    >
      <li class="relative pb-14">
        <div
          class="absolute left-1/2 top-4 -ml-px mt-0.5 h-full w-px bg-gray-300"
          aria-hidden="true"
        />
        <div class="border border-gray-300 shadow-sm bg-white pt-2 px-5 pb-2.5 relative z-10 rounded flex items-center gap-2 font-semibold">
          <span>Start</span>
          <SvgIcon
            aria-hidden="true"
            icon-name="arrow"
            class="shrink-0 rotate-90 h-4"
            width="16"
            height="16"
          />
        </div>
      </li>

      <li
        v-for="(lesson, index) in lessons"
        :key="lesson.uuid"
        class="relative pb-14"
      >
        <div
          class="absolute -top-5 -left-5 lg:-top-10 lg:-left-10 z-20 border border-gray-300 h-14 w-14 lg:h-20 lg:w-20 flex items-center justify-center bg-white rounded-full text-gray-800 text-4xl font-semibold"
          v-text="index + 1"
        />
        <div
          class="absolute left-1/2 top-4 -ml-px mt-0.5 h-full w-px bg-gray-300"
          aria-hidden="true"
        />
        <div class="group relative flex items-start">
          <LessonCard
            :lesson="lesson as LessonRecord"
            :is-details="true"
          />
        </div>
      </li>

      <li class="relative">
        <div class="border border-gray-300 shadow-sm bg-white pt-2 px-5 pb-2.5 relative z-10 rounded flex items-center gap-2 font-semibold">
          <SvgIcon
            aria-hidden="true"
            icon-name="party-horn"
            class="shrink-0 h-4"
            width="16"
            height="16"
          />
          <span>Finish!</span>
        </div>
      </li>
    </ol>
  </div>
</template>

<script lang="ts">
export default { name: 'PathLessons' }
</script>

<script setup lang="ts">
import { computed } from 'vue'
import type { Ref } from 'vue'

import { useExternalContent } from '~/composables/useExternalContent'
import { useExpandEntitiesFromAlgolia } from '~/composables/useExpandEntitiesFromAlgolia'

import { RecordType } from '~/types/records/RecordType'
import { LessonRecord } from '~/types/records/LessonRecord'

import LessonCard from '~/components/externalContent/lessons/LessonCard.vue'

const props = defineProps<{
  pathEnc: string,
}>()

const {
  algoliaRecord: algoliaPath,
} = useExternalContent(props.pathEnc)

const algoliaLessons = useExpandEntitiesFromAlgolia(RecordType.Lesson, algoliaPath.lessons) as Ref<LessonRecord[]>

const lessons = computed(
  () => algoliaLessons.value.map(
    lesson => ({
      ...lesson,
      path: algoliaPath,
    }),
  ),
)
</script>
